import AppModal from './AppModal.js'

var MyApp = new AppModal()
export default MyApp
